// extracted by mini-css-extract-plugin
var _1 = "PaymentCard-module__cardDeclined--SqOXn";
export { _1 as "cardDeclined" }
